import { Indicator } from "../interfaces/ODSPriorityGroups";

interface Column<T> {
    label: string;
    accessor: keyof T;
    sortable?: boolean;
    render?: (value: T[keyof T], row: T) => React.ReactNode;
    getValue?: (row: T) => any;
}

export function getSortedIndicators(
    data: Indicator[],
    columns: Column<Indicator>[],
    sortConfig: { key: keyof Indicator | null; direction: 'asc' | 'desc' }
): Indicator[] {
    const customOrderAsc = [-1, 1, 0, null];
    const customOrderDesc = [null, 0, 1, -1];

    return [...data].sort((a, b) => {
        const sortColumn = columns.find(col => col.accessor === sortConfig.key);
        if (!sortColumn || !sortConfig.key) return 0;

        const aValue = sortColumn.getValue ? sortColumn.getValue(a) : a[sortConfig.key];
        const bValue = sortColumn.getValue ? sortColumn.getValue(b) : b[sortConfig.key];

        // Si son strings, ordenar alfabéticamente
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return sortConfig.direction === 'asc'
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        }

        const orderArray = sortConfig.direction === 'asc' ? customOrderAsc : customOrderDesc;

        const aIndex = orderArray.indexOf(aValue);
        const bIndex = orderArray.indexOf(bValue);

        return aIndex - bIndex;
    });
}
